import { render, staticRenderFns } from "./certAdvs.vue?vue&type=template&id=52ffc4d1&scoped=true&"
import script from "./certAdvs.vue?vue&type=script&lang=js&"
export * from "./certAdvs.vue?vue&type=script&lang=js&"
import style0 from "./certAdvs.vue?vue&type=style&index=0&id=52ffc4d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffc4d1",
  null
  
)

export default component.exports